import { render, staticRenderFns } from "./navigator.vue?vue&type=template&id=c9e46a64&scoped=true"
import script from "./navigator.vue?vue&type=script&lang=js"
export * from "./navigator.vue?vue&type=script&lang=js"
import style0 from "./navigator.vue?vue&type=style&index=0&id=c9e46a64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e46a64",
  null
  
)

export default component.exports